function debounce(e, t) {
    let s;
    return (...n) => {
        clearTimeout(s), s = setTimeout((() => e.apply(this, n)), t)
    }
}
var dispatchCustomEvent = function(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        s = new CustomEvent(e, t ? {
            detail: t
        } : null);
    document.dispatchEvent(s)
};
if (window.recentlyViewedIds = [], !customElements.get("quantity-selector")) {
    class e extends HTMLElement {
        constructor() {
            super(), this.input = this.querySelector(".qty"), this.step = this.input.getAttribute("step"), this.changeEvent = new Event("change", {
                bubbles: !0
            }), this.subtract = this.querySelector(".minus"), this.add = this.querySelector(".plus"), this.subtract.addEventListener("click", (() => this.change_quantity(-1 * this.step))), this.add.addEventListener("click", (() => this.change_quantity(1 * this.step)))
        }
        connectedCallback() {
            this.classList.add("buttons_added"), this.validateQtyRules()
        }
        change_quantity(e) {
            let t = Number(this.input.value);
            isNaN(t) && (t = 1), this.input.getAttribute("min") > t + e || this.input.getAttribute("max") && this.input.getAttribute("max") < t + e || (t += e, t = Math.max(t, 1), this.input.value = t, this.input.dispatchEvent(this.changeEvent), this.validateQtyRules())
        }
        validateQtyRules() {
            const e = parseInt(this.input.value);
            if (this.input.min) {
                const t = parseInt(this.input.min);
                this.subtract.classList.toggle("disabled", e <= t)
            }
            if (this.input.max) {
                const t = parseInt(this.input.max);
                this.add.classList.toggle("disabled", e >= t)
            }
        }
    }
    customElements.define("quantity-selector", e)
}
class ArrowSubMenu {
    constructor(e) {
        this.submenu = e.parentNode.querySelector(".sub-menu"), this.arrow = e, e.addEventListener("click", (e => this.toggle_submenu(e)))
    }
    toggle_submenu(e) {
        e.preventDefault();
        let t = this.submenu;
        t.classList.contains("active") ? (t.classList.remove("active"), this.arrow.blur()) : t.classList.add("active")
    }
}
let arrows = document.querySelectorAll(".thb-arrow");
if (arrows.forEach((e => {
        new ArrowSubMenu(e)
    })), !customElements.get("product-card")) {
    class e extends HTMLElement {
        constructor() {
            super(), this.swatches = this.querySelector(".product-card-swatches"), this.image = this.querySelector(".product-featured-image-link .product-primary-image"), this.additional_images = this.querySelectorAll(".product-secondary-image"), this.additional_images_nav = this.querySelectorAll(".product-secondary-images-nav li"), this.quick_add = this.querySelector(".product-card--add-to-cart-button-simple")
        }
        connectedCallback() {
            this.swatches && this.enableSwatches(this.swatches, this.image), this.additional_images && this.enableAdditionalImages(), this.quick_add && this.enableQuickAdd()
        }
        enableAdditionalImages() {
            let e = this.additional_images.length,
                t = this.additional_images,
                s = this.additional_images_nav,
                n = this.querySelector(".product-featured-image");
            const i = function(n) {
                    let i = n.offsetX / this.getBoundingClientRect().width,
                        o = Math.floor(i * e),
                        c = t[o];
                    t.forEach(((e, t) => {
                        e.classList.contains("hover") && (e.classList.remove("hover"), s.length && s[t].classList.remove("active"))
                    })), c && (c.classList.contains("hover") || (c.classList.add("hover"), s.length && s[o].classList.add("active")))
                },
                o = function(e) {
                    t.forEach(((e, t) => {
                        e.classList.remove("hover"), s.length && s[t].classList.remove("active")
                    }))
                };
            n && (n.addEventListener("touchstart", i, {
                passive: !0
            }), n.addEventListener("touchmove", i, {
                passive: !0
            }), n.addEventListener("touchend", o, {
                passive: !0
            }), n.addEventListener("mouseenter", i, {
                passive: !0
            }), n.addEventListener("mousemove", i, {
                passive: !0
            }), n.addEventListener("mouseleave", o, {
                passive: !0
            }))
        }
        enableSwatches(e, t) {
            let s = e.querySelectorAll(".product-card-swatch"),
                n = t ? t.dataset.srcset : "";
            e.querySelector(".product-card-swatch.active");
            s.forEach(((e, i) => {
                e.addEventListener("mouseover", (function() {
                    [].forEach.call(s, (function(e) {
                        e.classList.remove("active")
                    })), t && (e.dataset.srcset ? t.setAttribute("srcset", e.dataset.srcset) : t.setAttribute("srcset", n)), e.classList.add("active")
                })), e.addEventListener("click", (function(e) {
                    window.location.href = this.dataset.href, e.preventDefault()
                }))
            }))
        }
        enableQuickAdd() {
            this.quick_add.addEventListener("click", this.quickAdd.bind(this))
        }
        quickAdd(e) {
            if (e.preventDefault(), this.quick_add.disabled) return;
            this.quick_add.classList.add("loading"), this.quick_add.setAttribute("aria-disabled", !0);
            const t = {
                method: "POST",
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    Accept: "application/javascript"
                }
            };
            let s = new FormData(this.form);
            return s.append("id", this.quick_add.dataset.productId), s.append("quantity", 1), s.append("sections", this.getSectionsToRender().map((e => e.section))), s.append("sections_url", window.location.pathname), t.body = s, fetch(`${theme.routes.cart_add_url}`, t).then((e => e.json())).then((e => {
                e.status || (this.renderContents(e), dispatchCustomEvent("cart:item-added", {
                    product: e.hasOwnProperty("items") ? e.items[0] : e
                }))
            })).catch((e => {
                console.error(e)
            })).finally((() => {
                this.quick_add.classList.remove("loading"), this.quick_add.removeAttribute("aria-disabled")
            })), !1
        }
        getSectionsToRender() {
            return [{
                id: "Cart",
                section: "main-cart",
                selector: ".thb-cart-form"
            }, {
                id: "Cart-Drawer",
                section: "cart-drawer",
                selector: ".cart-drawer"
            }, {
                id: "cart-drawer-toggle",
                section: "cart-bubble",
                selector: ".thb-item-count"
            }]
        }
        renderContents(e) {
            this.getSectionsToRender().forEach((t => {
                if (!document.getElementById(t.id)) return;
                (document.getElementById(t.id).querySelector(t.selector) || document.getElementById(t.id)).innerHTML = this.getSectionInnerHTML(e.sections[t.section], t.selector), void 0 !== CartDrawer && new CartDrawer, "undefined" != typeof Cart && (new Cart).renderContents(e)
            })), document.getElementById("Cart-Drawer") && (document.getElementById("Cart-Drawer").classList.add("active"), document.body.classList.add("open-cart"), document.body.classList.add("open-cc"), document.getElementById("Cart-Drawer").querySelector(".product-recommendations--full") && document.getElementById("Cart-Drawer").querySelector(".product-recommendations--full").classList.add("active"), dispatchCustomEvent("cart-drawer:open"))
        }
        getSectionInnerHTML(e, t = ".shopify-section") {
            return (new DOMParser).parseFromString(e, "text/html").querySelector(t).innerHTML
        }
    }
    customElements.define("product-card", e)
}
if (!customElements.get("variant-card")) {
    class e extends HTMLElement {
        constructor() {
            super(), this.quick_add = this.querySelector(".product-card--add-to-cart-button-simple")
        }
        connectedCallback() {
            this.quick_add && this.quick_add.addEventListener("click", this.quickAdd.bind(this))
        }
        enableQuickAdd() {
            this.quick_add.addEventListener("click", this.quickAdd.bind(this))
        }
        quickAdd(e) {
            if (e.preventDefault(), this.quick_add.disabled) return;
            this.quick_add.classList.add("loading"), this.quick_add.setAttribute("aria-disabled", !0);
            const t = {
                method: "POST",
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    Accept: "application/javascript"
                }
            };
            let s = new FormData(this.form);
            return s.append("id", this.quick_add.dataset.productId), s.append("quantity", 1), s.append("sections", this.getSectionsToRender().map((e => e.section))), s.append("sections_url", window.location.pathname), t.body = s, fetch(`${theme.routes.cart_add_url}`, t).then((e => e.json())).then((e => {
                e.status || (this.renderContents(e), dispatchCustomEvent("cart:item-added", {
                    product: e.hasOwnProperty("items") ? e.items[0] : e
                }))
            })).catch((e => {
                console.error(e)
            })).finally((() => {
                this.quick_add.classList.remove("loading"), this.quick_add.removeAttribute("aria-disabled")
            })), !1
        }
        getSectionsToRender() {
            return [{
                id: "Cart",
                section: "main-cart",
                selector: ".thb-cart-form"
            }, {
                id: "Cart-Drawer",
                section: "cart-drawer",
                selector: ".cart-drawer"
            }, {
                id: "cart-drawer-toggle",
                section: "cart-bubble",
                selector: ".thb-item-count"
            }]
        }
        renderContents(e) {
            this.getSectionsToRender().forEach((t => {
                if (!document.getElementById(t.id)) return;
                (document.getElementById(t.id).querySelector(t.selector) || document.getElementById(t.id)).innerHTML = this.getSectionInnerHTML(e.sections[t.section], t.selector), void 0 !== CartDrawer && new CartDrawer, "undefined" != typeof Cart && (new Cart).renderContents(e)
            })), document.getElementById("Cart-Drawer") && (document.getElementById("Cart-Drawer").classList.add("active"), document.body.classList.add("open-cart"), document.body.classList.add("open-cc"), document.getElementById("Cart-Drawer").querySelector(".product-recommendations--full") && document.getElementById("Cart-Drawer").querySelector(".product-recommendations--full").classList.add("active"), dispatchCustomEvent("cart-drawer:open"))
        }
        getSectionInnerHTML(e, t = ".shopify-section") {
            return (new DOMParser).parseFromString(e, "text/html").querySelector(t).innerHTML
        }
    }
    customElements.define("variant-card", e)
}
class Header {
    constructor() {
        const e = document.querySelector(".header-section"),
            t = document.getElementById("header"),
            s = document.getElementById("mobile-menu"),
            n = document.querySelector(".mobile-toggle-wrapper"),
            i = this.setHeaderOffset,
            o = this.setAnnouncementHeight,
            c = this.setHeaderHeight;
        if (t) {
            if (document.addEventListener("keyup", (e => {
                    e.code && "ESCAPE" === e.code.toUpperCase() && (n.removeAttribute("open"), n.classList.remove("active"))
                })), n.querySelector(".mobile-toggle").addEventListener("click", (t => {
                    o(e), n.classList.contains("active") ? (t.preventDefault(), document.body.classList.remove("overflow-hidden"), n.classList.remove("active"), this.closeAnimation(n)) : (document.body.classList.add("overflow-hidden"), setTimeout((() => {
                        n.classList.add("active")
                    }))), window.dispatchEvent(new Event("resize.resize-select"))
                })), window.addEventListener("scroll", (function() {
                    if (i(e), c(t), t.classList.contains("header-sticky--active")) {
                        let e = parseInt(t.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
                        t.classList.toggle("is-sticky", window.scrollY >= e && window.scrollY > 0)
                    }
                }), {
                    passive: !0
                }), window.dispatchEvent(new Event("scroll")), document.getElementById("shopify-section-announcement-bar")) {
                const e = document.getElementById("shopify-section-announcement-bar");
                window.addEventListener("resize", (function() {
                    o(e)
                }), {
                    passive: !0
                }), window.dispatchEvent(new Event("resize"))
            }
            s.querySelectorAll("summary").forEach((e => e.addEventListener("click", this.onSummaryClick.bind(this)))), s.querySelectorAll("button").forEach((e => e.addEventListener("click", this.onCloseButtonClick.bind(this))))
        }
    }
    setAnnouncementHeight(e) {
        let t = e.clientHeight;
        document.documentElement.style.setProperty("--announcement-height", t + "px")
    }
    setHeaderOffset(e) {
        let t = e.getBoundingClientRect().top;
        document.documentElement.style.setProperty("--header-offset", t + "px")
    }
    setHeaderHeight(e) {
        let t = e.clientHeight;
        document.documentElement.style.setProperty("--header-height", t + "px")
    }
    onSummaryClick(e) {
        const t = e.currentTarget.parentNode,
            s = t.closest(".link-container");
        t.hasAttribute("open");
        setTimeout((() => {
            t.classList.add("menu-opening"), s && s.classList.add("submenu-open")
        }), 100)
    }
    onCloseButtonClick(e) {
        e.preventDefault();
        const t = e.currentTarget.closest("details");
        this.closeSubmenu(t)
    }
    closeSubmenu(e) {
        e.classList.remove("menu-opening"), this.closeAnimation(e)
    }
    closeAnimation(e) {
        let t;
        const s = n => {
            void 0 === t && (t = n);
            n - t < 400 ? window.requestAnimationFrame(s) : (e.removeAttribute("open"), e.querySelectorAll("details").forEach((e => {
                e.removeAttribute("open"), e.classList.remove("menu-opening"), e.classList.remove("submenu-open")
            })))
        };
        window.requestAnimationFrame(s)
    }
}
if (!customElements.get("full-menu")) {
    class e extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            if (this.submenus = this.querySelectorAll(".thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu"), !this.submenus.length) return;
            const e = this;
            window.addEventListener("resize", debounce((function() {
                e.resizeSubMenus()
            }), 100)), window.dispatchEvent(new Event("resize")), document.fonts.ready.then((function() {
                e.resizeSubMenus()
            }))
        }
        resizeSubMenus() {
            this.submenus.forEach((e => {
                e.querySelectorAll(":scope >.menu-item-has-children>.sub-menu").forEach((e => {
                    e.offsetWidth + (e.parentElement.parentElement.getBoundingClientRect().left + e.parentElement.parentElement.clientWidth + 10) > document.body.clientWidth ? e.parentElement.classList.add("left-submenu") : e.parentElement.classList.contains("left-submenu") && e.parentElement.classList.remove("left-submenu")
                }))
            }))
        }
    }
    customElements.define("full-menu", e)
}
if (!customElements.get("side-panel-close")) {
    class e extends HTMLElement {
        constructor() {
            super();
            let e = document.querySelector(".click-capture");
            this.addEventListener("click", (e => this.close_panel(e))), document.addEventListener("panel:close", (e => {
                let t = document.querySelectorAll(".side-panel.active");
                t && this.close_panel(e, t[0])
            })), e.addEventListener("click", (e => {
                let t = document.querySelectorAll(".side-panel.active");
                t && this.close_panel(e, t[0])
            }))
        }
        close_panel(e, t) {
            e && e.preventDefault(), (t || (t = e.target.closest(".side-panel"))) && (t.classList.contains("product-drawer") ? this.close_quick_view(t) : t.classList.contains("cart-drawer") ? (t.querySelector(".product-recommendations--full") && (document.body.classList.contains("open-quick-view") || t.querySelector(".product-recommendations--full").classList.remove("active")), window.innerWidth < 1069 ? document.body.classList.contains("open-quick-view") ? this.close_quick_view() : (t.classList.remove("active"), document.body.classList.remove("open-cc"), document.body.classList.remove("open-cart")) : t.querySelector(".product-recommendations--full") ? document.body.classList.contains("open-quick-view") ? this.close_quick_view() : setTimeout((() => {
                t.classList.remove("active"), document.body.classList.remove("open-cc"), document.body.classList.remove("open-cart")
            }), 500) : (t.classList.remove("active"), document.body.classList.remove("open-cc"), document.body.classList.remove("open-cart"))) : (t.classList.remove("active"), document.body.classList.remove("open-cc")))
        }
        close_quick_view(e) {
            (e = e || document.getElementById("Product-Drawer")).querySelector(".product-quick-images--container") && e.querySelector(".product-quick-images--container").classList.remove("active"), window.innerWidth < 1069 ? (e.classList.remove("active"), document.body.classList.contains("open-cart") || document.body.classList.remove("open-cc"), document.body.classList.remove("open-quick-view")) : e.querySelector(".product-quick-images--container") && setTimeout((() => {
                e.classList.remove("active"), document.body.classList.contains("open-cart") || document.body.classList.remove("open-cc"), document.body.classList.remove("open-quick-view"), e.querySelector("#Product-Drawer-Content").innerHTML = ""
            }), 500)
        }
    }
    customElements.define("side-panel-close", e), document.addEventListener("keyup", (e => {
        e.code && "ESCAPE" === e.code.toUpperCase() && dispatchCustomEvent("panel:close")
    }))
}
class CartDrawer {
    constructor() {
        this.container = document.getElementById("Cart-Drawer");
        if (!this.container) return;

        const toggleBtn = document.getElementById("cart-drawer-toggle");

        // Open drawer
        toggleBtn.addEventListener("click", e => {
            e.preventDefault();
            document.body.classList.add("open-cc", "open-cart");
            this.container.classList.add("active");
            this.container.focus();
            setTimeout(() => {
                const recs = this.container.querySelector(".product-recommendations--full");
                recs && recs.classList.add("active");
            });
            dispatchCustomEvent("cart-drawer:open");
        });

        // Debounced quantity change
        this.debouncedOnChange = debounce(e => this.onChange(e), 300);
        this.container.addEventListener("change", this.debouncedOnChange.bind(this));

        // Use delegation for remove buttons
        this.container.addEventListener("click", e => {
            if (e.target.matches(".remove")) {
                e.preventDefault();
                this.updateQuantityByKey(e.target.dataset.key, "0");
            }
        });

        this.notesToggle();
        this.termsCheckbox();
        this.updateFreeShipping();
    }

    onChange(e) {
        if (e.target.classList.contains("qty")) {
            this.updateQuantity(e.target.dataset.index, e.target.value);
        }
    }

    getSectionsToRender() {
        return [
            { id: "Cart-Drawer", section: "cart-drawer", selector: ".cart-drawer" },
            { id: "cart-drawer-toggle", section: "cart-bubble", selector: ".thb-item-count" }
        ];
    }

    getSectionInnerHTML(e, t) {
        return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
    }

    termsCheckbox() {
        const checkbox = this.container.querySelector("#CartDrawerTerms");
        const checkoutBtn = this.container.querySelector(".button.checkout");
        if (checkbox && checkoutBtn) {
            checkbox.setCustomValidity(theme.strings.requiresTerms);
            checkoutBtn.addEventListener("click", e => {
                if (!checkbox.checked) {
                    checkbox.reportValidity();
                    checkbox.focus();
                    e.preventDefault();
                }
            });
        }
    }

    notesToggle() {
        const toggle = document.getElementById("order-note-toggle");
        if (!toggle) return;
        const noteContainer = toggle.nextElementSibling;

        toggle.addEventListener("click", () => {
            noteContainer.classList.add("active");
        });

        noteContainer.querySelectorAll(".button, .order-note-toggle__content-overlay").forEach(btn => {
            btn.addEventListener("click", () => {
                noteContainer.classList.remove("active");
                this.saveNotes();
            });
        });
    }

    saveNotes() {
        fetch(`${theme.routes.cart_update_url}.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ note: document.getElementById("mini-cart__notes").value })
        });
    }

    updateFreeShipping() {
        const free = this.container.querySelector(".free-shipping");
        if (!free) return;

        const span = free.querySelector(".free-shipping--text span");
        const total = parseInt(free.dataset.cartTotal, 10);
        const minimum = Math.round(parseInt(free.dataset.minimum, 10) * (Shopify.currency.rate || 1));
        let percentage = 1;

        if (total < minimum && span) {
            const remaining = minimum - total;
            const format = window.theme.settings.money_with_currency_format || "${{amount}}";
            span.innerHTML = formatMoney(remaining, format);
            percentage = total / minimum;
        }
        free.style.setProperty("--percentage", percentage);
    }

    updateQuantity(index, qty) {
        const item = this.container.querySelector(`#CartDrawerItem-${index}`);
        if (item) item.classList.add("thb-loading");

        const payload = JSON.stringify({
            line: index,
            quantity: qty,
            sections: this.getSectionsToRender().map(e => e.section),
            sections_url: window.location.pathname
        });

        dispatchCustomEvent("line-item:change:start", { quantity: qty });

        this.container.querySelector(".product-recommendations--full")?.classList.remove("active");

        fetch(`${theme.routes.cart_change_url}`, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: payload
        })
            .then(res => res.json())
            .then(cart => {
                this.getSectionsToRender().forEach(section => {
                    const el = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                    if (cart.sections && cart.sections[section.section]) {
                        el.innerHTML = this.getSectionInnerHTML(cart.sections[section.section], section.selector);
                    }
                });

                this.notesToggle();
                this.termsCheckbox();
                this.updateFreeShipping();
                dispatchCustomEvent("line-item:change:end", { quantity: qty, cart });

                if (item) item.classList.remove("thb-loading");
            });
    }

    updateQuantityByKey(lineItemKey, qty) {
      const item = this.container.querySelector(`[data-line-key="${lineItemKey}"]`);
      if (item) item.classList.add("thb-loading");

      const payload = JSON.stringify({
          id: lineItemKey,       // Use key instead of index
          quantity: qty,
          sections: this.getSectionsToRender().map(e => e.section),
          sections_url: window.location.pathname
      });

      dispatchCustomEvent("line-item:change:start", { quantity: qty });

      this.container.querySelector(".product-recommendations--full")?.classList.remove("active");

      fetch(`${theme.routes.cart_change_url}`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: payload
      })
          .then(res => res.json())
          .then(cart => {
              this.getSectionsToRender().forEach(section => {
                  const el = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                  if (cart.sections && cart.sections[section.section]) {
                      el.innerHTML = this.getSectionInnerHTML(cart.sections[section.section], section.selector);
                  }
              });

              // Rebind any dynamic features
              this.notesToggle();
              this.termsCheckbox();
              this.updateFreeShipping();
              dispatchCustomEvent("line-item:change:end", { quantity: qty, cart });

              if (item) item.classList.remove("thb-loading");
          });
  }

}

class ModalDialog extends HTMLElement {
    constructor() {
        super(), this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this)), this.addEventListener("keyup", (e => {
            "ESCAPE" === e.code.toUpperCase() && this.hide()
        })), this.classList.contains("media-modal") ? this.addEventListener("pointerup", (e => {
            "mouse" !== e.pointerType || e.target.closest("product-model") || this.hide()
        })) : this.addEventListener("click", (e => {
            "MODAL-DIALOG" === e.target.nodeName && this.hide()
        }))
    }
    connectedCallback() {
        this.moved || (this.moved = !0, document.body.appendChild(this))
    }
    show(e) {
        this.openedBy = e, document.body.classList.add("overflow-hidden"), this.setAttribute("open", "")
    }
    hide() {
        document.body.classList.remove("overflow-hidden"), this.removeAttribute("open"), this.querySelectorAll(".js-youtube").forEach((e => {
            e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
        })), this.querySelectorAll(".js-vimeo").forEach((e => {
            e.contentWindow.postMessage('{"method":"pause"}', "*")
        })), this.querySelectorAll("video").forEach((e => e.pause()))
    }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
    constructor() {
        super();
        const e = this.querySelector("button");
        e && e.addEventListener("click", (() => {
            const t = document.querySelector(this.getAttribute("data-modal"));
            t && t.show(e)
        }))
    }
}
customElements.define("modal-opener", ModalOpener);
class Localization {
    constructor() {
        document.querySelectorAll(".thb-localization-forms").forEach((e => {
            e.addEventListener("change", (t => {
                e.querySelector("form").submit()
            }))
        }))
    }
}
class SelectWidth {
    constructor() {
        let e = this;
        window.addEventListener("load", (() => {
            document.querySelectorAll(".resize-select").forEach(e.resizeSelect)
        })), document.body.addEventListener("change", (t => {
            t.target.matches(".resize-select") && null !== t.target.offsetParent && e.resizeSelect(t.target)
        })), window.addEventListener("resize.resize-select", (function() {
            document.querySelectorAll(".resize-select").forEach(e.resizeSelect)
        }))
    }
    resizeSelect(e) {
        let t = document.createElement("option");
        t.textContent = e.selectedOptions[0].textContent;
        let s = document.createElement("select"),
            n = 13;
        s.style.visibility = "hidden", s.style.position = "fixed", s.appendChild(t), (e.classList.contains("thb-language-code") || e.classList.contains("thb-currency-code") || e.classList.contains("facet-filters__sort")) && (n = 2), e.after(s), s.clientWidth > 0 && (e.style.width = `${+s.clientWidth+n}px`), s.remove()
    }
}
void 0 !== SelectWidth && new SelectWidth;
class FooterMenuToggle {
    constructor() {
        document.querySelectorAll(".thb-widget-title.collapsible").forEach((e => {
            e.addEventListener("click", (t => {
                e.classList.toggle("active")
            }))
        }))
    }
}
if (!customElements.get("quick-view")) {
    class e extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            this.cc = document.querySelector(".click-capture"), this.drawer = document.getElementById("Product-Drawer"), this.body = document.body, this.addEventListener("click", this.setupEventListener.bind(this))
        }
        setupEventListener(e) {
            e.preventDefault();
            let t = this.dataset.productHandle,
                s = `${theme.routes.root_url}/products/${t}?view=quick-view`;
            s = s.replace("//", "/"), s && t && (this.classList.contains("loading") || (this.classList.add("loading"), fetch(s, {
                method: "GET"
            }).then((e => (this.classList.remove("loading"), e.text()))).then((e => {
                const n = (new DOMParser).parseFromString(e, "text/html").querySelector("#Product-Drawer-Content").innerHTML;
                this.renderQuickview(n, s, t)
            }))))
        }
        renderQuickview(e, t, s) {
            if (e) {
                this.drawer.querySelector("#Product-Drawer-Content").innerHTML = e;
                let i = this.drawer.querySelector("#Product-Drawer-Content").querySelectorAll("script");
                if (i.length > 0) {
                    var n = document.getElementsByTagName("head")[0];
                    i.forEach(((e, t) => {
                        let s = document.createElement("script");
                        s.src = e.src, n.appendChild(s)
                    }))
                }
                setTimeout((() => {
                    Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(), window.ProductModel && window.ProductModel.loadShopifyXR()
                }), 300), this.body.classList.add("open-cc"), this.body.classList.add("open-quick-view"), this.drawer.classList.add("active"), this.drawer.querySelector(".side-panel-close").focus(), setTimeout((() => {
                    this.drawer.querySelector(".product-quick-images--container").classList.add("active")
                })), dispatchCustomEvent("quick-view:open", {
                    productUrl: t,
                    productHandle: s
                }), addIdToRecentlyViewed(s)
            }
        }
    }
    customElements.define("quick-view", e)
}
if (!customElements.get("side-panel-content-tabs")) {
    class e extends HTMLElement {
        constructor() {
            super(), this.buttons = this.querySelectorAll("button"), this.panels = this.parentElement.querySelectorAll(".side-panel-content--tab-panel")
        }
        connectedCallback() {
            this.setupButtonObservers()
        }
        disconnectedCallback() {}
        setupButtonObservers() {
            this.buttons.forEach(((e, t) => {
                e.addEventListener("click", (e => {
                    this.toggleActiveClass(t)
                }))
            }))
        }
        toggleActiveClass(e) {
            this.buttons.forEach((e => {
                e.classList.remove("tab-active")
            })), this.buttons[e].classList.add("tab-active"), this.panels.forEach((e => {
                e.classList.remove("tab-active")
            })), this.panels[e].classList.add("tab-active")
        }
    }
    customElements.define("side-panel-content-tabs", e)
}
if (!customElements.get("collapsible-row")) {
    class e extends HTMLElement {
        constructor() {
            super(), this.details = this.querySelector("details"), this.summary = this.querySelector(":not(header) summary"), this.content = this.querySelector(".collapsible__content")
        }
        connectedCallback() {
            this.setListeners()
        }
        setListeners() {
            document.body.classList.contains("animations-true") && "undefined" != typeof gsap && !this.classList.contains("header") && setTimeout((() => {
                this.prepareAnimations(), this.querySelector(":not(header) summary").addEventListener("click", (e => this.onClick(e)))
            }), 400)
        }
        prepareAnimations() {
            let e = this,
                t = this.querySelector(":not(header) summary").offsetHeight,
                s = this.querySelector(".collapsible__content").offsetHeight,
                n = t,
                i = t + s;
            this.tl = !1, this.tl = gsap.timeline({
                reversed: !e.details.open,
                paused: !0,
                inherit: !1,
                ease: "sine.inOut",
                onStart: function() {
                    e.details.open = !0, e.details.style.overflow = "hidden"
                },
                onReverseComplete: function() {
                    e.details.open = !1, e.details.style.overflow = ""
                }
            }), this.tl.fromTo(e.details, {
                height: function() {
                    return Math.max(Math.max(n, 0), 24)
                },
                clearProps: "height"
            }, {
                duration: .6,
                height: i,
                clearProps: "height"
            }), this.details.open && this.tl.progress(1)
        }
        instantClose() {
            this.tl.timeScale(10).reverse()
        }
        animateClose() {
            this.tl.timeScale(3).reverse()
        }
        animateOpen() {
            this.tl.timeScale(1).play()
        }
        onClick(e) {
            e.preventDefault(), this.tl.reversed() ? this.tl.timeScale(1).play() : this.tl.timeScale(3).reverse()
        }
    }
    customElements.define("collapsible-row", e)
}

function addIdToRecentlyViewed(e) {
    if (!e) {
        let t = document.querySelector(".thb-product-detail");
        if (t && !(e = t.dataset.handle)) return
    }
    if (window.localStorage) {
        let e = window.localStorage.getItem("recently-viewed");
        e && void 0 !== typeof e && (window.recentlyViewedIds = JSON.parse(e))
    }
    var t = window.recentlyViewedIds.indexOf(e);
    t > -1 && window.recentlyViewedIds.splice(t, 1), window.recentlyViewedIds.unshift(e), window.localStorage && window.localStorage.setItem("recently-viewed", JSON.stringify(window.recentlyViewedIds))
}
document.addEventListener("DOMContentLoaded", (() => {
    void 0 !== Localization && new Localization, void 0 !== CartDrawer && new CartDrawer, void 0 !== Header && new Header, void 0 !== FooterMenuToggle && new FooterMenuToggle
}));

document.addEventListener("DOMContentLoaded", function() {
    const faqBoxes = document.querySelectorAll(".faq-box");

    faqBoxes.forEach(box => {
        const head = box.querySelector(".faq-head");
        const answer = box.querySelector(".faq-text");
        const plusContainer = head.querySelector(".plus-container");

        // Replace image with inline SVG
        if (plusContainer) {
            plusContainer.innerHTML = `
        <svg class="faq-plus-icon" width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="10" y1="4" x2="10" y2="16" stroke="currentColor" stroke-width="2"/>
          <line x1="4" y1="10" x2="16" y2="10" stroke="currentColor" stroke-width="2"/>
        </svg>
      `;
        }

        // Hide answer by default
        answer.style.maxHeight = "0";
        answer.style.overflow = "hidden";
        answer.style.transition = "max-height 0.4s ease";

        head.addEventListener("click", () => {
            const isOpen = box.classList.contains("open");

            // Close all answers
            document.querySelectorAll(".faq-box").forEach(b => {
                b.classList.remove("open");
                b.querySelector(".faq-text").style.maxHeight = "0";
                const icon = b.querySelector(".faq-plus-icon");
                if (icon) icon.style.transform = "rotate(0deg)";
            });

            // Open current one if not already open
            if (!isOpen) {
                box.classList.add("open");
                answer.style.maxHeight = answer.scrollHeight + "px";

                const icon = box.querySelector(".faq-plus-icon");
                if (icon) icon.style.transform = "rotate(45deg)";
            }
        });
    });
});
